module.exports = "https://s91588.cdn.ngenix.net/creditselection-frontend/_next/static/images/family-1cc97df34eb64ce396cff4e318e60ef1.jpg";